let watchedElements = document.querySelectorAll(".js-bg-change");
let mainEl = document.querySelector('.home .site-main');
if (!mainEl){
  mainEl = document.querySelector('.single-throom .site-main');
}
if (mainEl) {
  mainEl.classList.add('rev-bg');
  // let isInViewport = function (element) {
  let overViewport = function (element) {
      const html = document.documentElement;
      var rect = element.getBoundingClientRect();
      return (
          html.scrollTop >= (rect.top)
          );
  };
  const scrollHandler = function (e) {
      console.log();
        for (let i = 0; i < watchedElements.length; i++) {
            if (overViewport(watchedElements[i])) {
                mainEl.classList.add("change");
            }else{
              mainEl.classList.remove("change");
            }
        }
  };
  if (watchedElements.length) {
    window.addEventListener('scroll', scrollHandler);
  }

}


// WEBPACK FOOTER //
// ./assets/src/js/modules/bg-change.js